var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3284_18604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18H2C1.46957 18 0.960859 17.7893 0.585787 17.4142C0.210714 17.0391 0 16.5304 0 16V2C0 1.46957 0.210714 0.960859 0.585787 0.585787C0.960859 0.210714 1.46957 0 2 0H16C16.5304 0 17.0391 0.210714 17.4142 0.585787C17.7893 0.960859 18 1.46957 18 2V16Z",
    fill: "#AC2519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74291 13.9645C7.74291 13.267 8.30041 12.678 8.99841 12.678C9.66491 12.678 10.2539 13.2825 10.2539 13.9645C10.2539 14.6 9.66491 15.1895 8.99841 15.1895C8.33191 15.189 7.74291 14.6155 7.74291 13.9645ZM10.1149 10.6005C10.1149 11.3445 9.6505 11.5 9 11.5C8.349 11.5 7.88291 11.345 7.88291 10.6005V4.64745C7.88291 3.90345 8.34791 3.40745 8.99891 3.40745C9.64991 3.40745 10.1149 3.90345 10.1149 4.64745V7.62395V10.6005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3284_18604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 -1 18 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconSquare);
export default __webpack_public_path__ + "static/media/infoIconSquare.83ddfd121c183f5f340b89930386e45d.svg";
export { ForwardRef as ReactComponent };